import React, { useState } from 'react';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core';
import FieldFormsDetails from './FieldFormsDetails';
import withAppStylesGrid from 'HOCs/withAppStyles';

import { getFieldFormSettings, ProjectConfiguration, deleteFieldForm } from 'utils/ProjectConfigurationUtil';


export default function GridFieldForms({ customFilter,callback }) {
  const columns = ProjectConfiguration.columnsTestFieldFormFields.filter(col => col.title !== "name")
  const theme = useTheme();

  const { selectedProject } = useAppContext();
  const [updateDate,setUpdateDate] = useState(new Date());
  const [page, setPage] = useState(0);
  const title = "Field Forms Settings";

  const DataGrid = withAppStylesGrid(MaterialTable, { defaultFilters: { projectId: selectedProject, ...customFilter }, theme, getRecords: getFieldFormSettings } )
   

  return (
    selectedProject && theme ?
      <>
        <>
          <DataGrid
            key={updateDate}
            style={{ boxShadow: "0 0 0 0" }}
            padding="dense"
            columns={columns}
            title={title}
            options={{
              headerStyle: {
                backgroundColor: theme.palette.grey[50],
                color: theme.palette.text.primary,
              },
              onPageChange: (e) => setPage(e),
              initialPage: page,
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
            detailPanel={rowData => {
              return (
                <FieldFormsDetails checklistItem={rowData}  callback={() => setUpdateDate(new Date)}></FieldFormsDetails>
              )
            }}
          />
        </>
      </> : <SkeletonGrid title={title} />
  )
}